import React from "react";
import InstIcon from "./instagram-2-1-logo-svgrepo-com.svg";

export default function InstagramIcon({ size }) {
  return (
    <div style={{ width: size ? size : "40px", height: size ? size : "40px" }}>
      <img style={{ width: "100%", height: "100%" }} src={InstIcon} alt="" />
    </div>
  );
}
